import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { MultipleDialogReq } from 'src/app/core/interfaces/test-code';

@Component({
    selector: 'app-multiple-linked-accountdialog',
    templateUrl: './multiple-linked-accountdialog.component.html',
    styleUrls: ['./multiple-linked-accountdialog.component.scss'],
    standalone: false
})
export class MultipleLinkedAccountdialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: MultipleDialogReq,
              public dialogRef: MatDialogRef<MultipleLinkedAccountdialogComponent>) { }

  ngOnInit() {
    // TODO document why this method 'ngOnInit' is empty
  
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
